// extracted by mini-css-extract-plugin
export default {"observatii":"Observatii_observatii__HHyVY"};